import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { Check, ShieldCheck, ArrowRight, Lock, CreditCard, Zap } from 'lucide-react';
import { motion } from 'framer-motion';
export function OfferSection() {
  const [selected, setSelected] = useState<'pro' | 'elite'>('elite');
  const links = {
    pro: 'https://salud-en-tu-plato.myshopify.com/checkouts/cn/hWNBBHxAji782rD1o9ipnZnm/es-ar?_r=AQABVqBSWHPN4Q1TFNqC4-LTVpLmSeyBScgVK1rMC8aAjRw&cart_link_id=oC8KVQWc&preview_theme_id=151828791463',
    elite: 'https://salud-en-tu-plato.myshopify.com/checkouts/cn/hWNBBHZcBauqe2E5MXhw79Ag/es-ar?_r=AQABSyFcTDZT3v4KJlGRuWHpd2MV3J4-ZFi6DetN1px-lkg&cart_link_id=qVfpENKk&preview_theme_id=151828791463'
  };
  const ctaText = {
    pro: '→ SÍ, QUIERO EL MEGAPACK PRO',
    elite: '→ SÍ, QUIERO EL MEGAPACK PRO + SISTEMA CLÍNICO PRO ELITE™'
  };
  return <section id="comprar" className="px-3 py-10 bg-[#0B1A3B]" data-id="element-95">
      <div className="max-w-[680px] mx-auto" data-id="element-96">
        <FadeIn className="text-center mb-6" data-id="element-97">
          <h2 className="text-2xl md:text-4xl font-bold text-white mb-2" data-id="element-98">
            Elegí tu <span className="text-accent" data-id="element-99">MegaPack Pro</span>
          </h2>
          <p className="text-base text-white/60" data-id="element-100">
            Las dos opciones incluyen acceso inmediato y bonos completos
          </p>
        </FadeIn>

        <div className="space-y-3 mb-5" data-id="element-101">
          {/* Card 1: Megapack */}
          <FadeIn delay={0.1} data-id="element-102">
            <div onClick={() => setSelected('pro')} className={`relative bg-[#0B1A3B] rounded-xl p-4 md:p-6 flex items-center gap-3 md:gap-5 cursor-pointer transition-all group ${selected === 'pro' ? 'border-2 border-accent shadow-[0_0_30px_rgba(123,147,253,0.15)]' : 'border border-accent/25 hover:border-accent/50'}`} data-id="element-103">
              <div className={`shrink-0 w-6 h-6 rounded-full border-2 flex items-center justify-center ${selected === 'pro' ? 'border-accent' : 'border-white/20 group-hover:border-accent/50'}`} data-id="element-104">
                <div className={`w-3 h-3 rounded-full ${selected === 'pro' ? 'bg-accent' : 'bg-transparent'}`} data-id="element-105" />
              </div>

              <div className="flex-1 min-w-0" data-id="element-106">
                <h3 className={`text-lg md:text-xl font-bold mb-1 ${selected === 'pro' ? 'text-accent' : 'text-white'}`} data-id="element-107">
                  MEGAPACK PRO
                </h3>
                <p className="text-white/50 text-sm md:text-base" data-id="element-108">
                  Acceso al megapack esencial + bonos
                </p>
              </div>

              <div className="text-right shrink-0" data-id="element-109">
                <p className="text-white/40 line-through text-sm mb-0.5" data-id="element-110">
                  $34.990
                </p>
                <p className={`text-2xl md:text-3xl font-bold ${selected === 'pro' ? 'text-accent' : 'text-white'}`} data-id="element-111">
                  $19.990
                </p>
              </div>
            </div>
          </FadeIn>

          {/* Card 2: Plus (Highlighted) */}
          <FadeIn delay={0.2} data-id="element-112">
            <div onClick={() => setSelected('elite')} className={`relative bg-[#0B1A3B] rounded-xl p-4 md:p-6 flex items-center gap-3 md:gap-5 cursor-pointer transition-all ${selected === 'elite' ? 'border-2 border-accent shadow-[0_0_30px_rgba(123,147,253,0.15)]' : 'border border-accent/25 hover:border-accent/50'}`} data-id="element-113">
              <div className="absolute -top-3 left-6 flex items-center gap-2" data-id="element-114">
                <span className="bg-accent text-black text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider" data-id="element-115">
                  MÁS ELEGIDO
                </span>
                <span className="text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider bg-[#C9A96E]" data-id="element-116">
                  AHORRÁS $16.000
                </span>
              </div>

              <div className={`shrink-0 w-6 h-6 rounded-full border-2 flex items-center justify-center ${selected === 'elite' ? 'border-accent' : 'border-white/20'}`} data-id="element-117">
                <div className={`w-3 h-3 rounded-full ${selected === 'elite' ? 'bg-accent' : 'bg-transparent'}`} data-id="element-118" />
              </div>

              <div className="flex-1 min-w-0 pt-2" data-id="element-119">
                <h3 className={`text-lg md:text-xl font-bold mb-1 leading-tight ${selected === 'elite' ? 'text-accent' : 'text-white'}`} data-id="element-120">
                  MEGAPACK PRO + SISTEMA CLÍNICO PRO ELITE™
                </h3>
                <p className="text-white/60 text-sm md:text-base" data-id="element-121">
                  Incluye el megapack inicial + sistemas específicos
                </p>
              </div>

              <div className="text-right shrink-0 pt-2" data-id="element-122">
                <p className="text-white/40 line-through text-sm mb-0.5" data-id="element-123">
                  $43.990
                </p>
                <p className={`text-2xl md:text-3xl font-bold ${selected === 'elite' ? 'text-accent' : 'text-white'}`} data-id="element-124">
                  $27.990
                </p>
              </div>
            </div>
          </FadeIn>
        </div>

        {/* Main CTA */}
        <FadeIn delay={0.3} className="text-center mb-5" data-id="element-125">
          <motion.a href={links[selected]} target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="block w-full bg-accent hover:bg-accent/90 text-black font-bold md:text-xl py-5 px-8 rounded-xl shadow-lg shadow-accent/20 transition-all text-center text-[16px]" data-id="element-126">
            {ctaText[selected]}
          </motion.a>
          <p className="text-white/50 text-xs mt-3 italic" data-id="element-127">
            La opción más elegida por quienes quieren avanzar más rápido y
            cobrar mejor
          </p>
        </FadeIn>

        {/* Trust Bar */}
        <FadeIn delay={0.4} className="mb-10" data-id="element-128">
          <div className="flex flex-wrap justify-center gap-4 md:gap-6 bg-surface border border-accent/25 rounded-lg py-3 px-4" data-id="element-129">
            <div className="flex items-center gap-2 text-white/60 text-sm font-medium" data-id="element-130">
              <Lock size={16} className="text-accent" data-id="element-131" />
              Pago seguro
            </div>
            <div className="flex items-center gap-2 text-white/60 text-sm font-medium" data-id="element-132">
              <Zap size={16} className="text-accent" data-id="element-133" />
              Acceso inmediato
            </div>
            <div className="flex items-center gap-2 text-white/60 text-sm font-medium" data-id="element-134">
              <ShieldCheck size={16} className="text-accent" data-id="element-135" />
              Garantía 7 días
            </div>
            <div className="flex items-center gap-2 text-white/60 text-sm font-medium" data-id="element-136">
              <CreditCard size={16} className="text-accent" data-id="element-137" />
              Mercado Pago
            </div>
          </div>
        </FadeIn>

        {/* Comparison Block */}
        <FadeIn delay={0.5} className="mb-10" data-id="element-138">
          <h3 className="text-xl font-bold text-center text-white mb-4" data-id="element-139">
            Sin Plus vs Con Sistema Clínico Pro Elite
          </h3>
          <div className="bg-surface border border-accent/25 rounded-2xl overflow-hidden" data-id="element-140">
            <div className="grid grid-cols-3 bg-white/5 p-4 border-b border-accent/25 font-bold text-sm md:text-base" data-id="element-141">
              <div className="text-white/60" data-id="element-142">Área</div>
              <div className="text-white/80 text-center" data-id="element-143">Estándar</div>
              <div className="text-accent text-center" data-id="element-144">Pro Elite</div>
            </div>

            {[{
            area: 'Abordaje',
            std: 'Clínica básica',
            plus: 'Protocolos avanzados'
          }, {
            area: 'Precios',
            std: 'Lo que cobrás hoy',
            plus: 'Sistema para aumentar honorarios'
          }, {
            area: 'Patologías',
            std: 'Generales',
            plus: 'Casos complejos y estancados'
          }, {
            area: 'Retención',
            std: 'Depende del paciente',
            plus: 'Estrategias de fidelización'
          }, {
            area: 'Organización',
            std: 'Orden básico',
            plus: 'Automatización y flujos'
          }, {
            area: 'Marketing',
            std: 'No incluye',
            plus: 'Plan de captación 12 meses'
          }].map((row, i) => <div key={i} className="grid grid-cols-3 p-4 border-b border-white/5 text-sm md:text-base items-center" data-id="element-145">
                <div className="font-medium text-white/70" data-id="element-146">{row.area}</div>
                <div className="text-center text-white/60" data-id="element-147">{row.std}</div>
                <div className="text-center text-accent font-medium flex items-center justify-center gap-2" data-id="element-148">
                  <Check size={16} className="hidden md:block" data-id="element-149" /> {row.plus}
                </div>
              </div>)}
          </div>
        </FadeIn>

        {/* Objections */}
        <FadeIn delay={0.6} data-id="element-150">
          <div className="grid md:grid-cols-3 gap-4" data-id="element-151">
            <div className="bg-surface border border-accent/25 p-4 rounded-xl" data-id="element-152">
              <h4 className="font-bold text-accent mb-2" data-id="element-153">
                ¿Y si soy recién recibido?
              </h4>
              <p className="text-white/70 text-sm" data-id="element-154">
                Te da la estructura clínica y seguridad que la facultad no te
                dio para tu primera consulta. Entrás con ventaja.
              </p>
            </div>
            <div className="bg-surface border border-accent/25 p-4 rounded-xl" data-id="element-155">
              <h4 className="font-bold text-accent mb-2" data-id="element-156">
                ¿Y si ya tengo experiencia?
              </h4>
              <p className="text-white/70 text-sm" data-id="element-157">
                Te ahorra horas de armado de protocolos y te da un sistema
                pulido para escalar pacientes complejos sin quemarte la cabeza.
              </p>
            </div>
            <div className="bg-surface border border-accent/25 p-4 rounded-xl" data-id="element-158">
              <h4 className="font-bold text-accent mb-2" data-id="element-159">¿Y si no me sirve?</h4>
              <p className="text-white/70 text-sm" data-id="element-160">
                Tenés 7 días de garantía total. Si sentís que no te suma valor
                clínico, te devolvemos el dinero sin hacer preguntas.
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}